import { graphql, compose } from "react-apollo"
import { connect } from "react-redux"
import { createMatchSelector, push } from "react-router-redux"
import gql from "graphql-tag"

import { NotFoundError } from "@swipesense/error-handling"

import routes from "../../routes"
import UtilizationSummaryTableControlled from "./UtilizationSummaryTableControlled"

const query = gql`
  query AssetUtilizationDepartments($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      name
      managedByCurrentUser
      departments {
        id
        name
      }
    }
  }
`

const mapDispatchToProps = dispatch => ({
  pushPath: path => {
    dispatch(push(path))
  },
})

export default compose(
  connect(
    ({ router }) => ({
      facilityId: createMatchSelector(routes.facility)({ router }).params
        .facilityId,
    }),
    mapDispatchToProps
  ),
  graphql(query, {
    options: ({ facilityId }) => ({
      variables: { facilityId },
    }),
    props: ({ data: { loading, error, facility } }) => {
      if (loading) {
        return { loading }
      } else if (error) {
        throw error
      } else if (!facility) {
        throw new NotFoundError()
      } else {
        let defaultEntityId, defaultEntityType

        const departments = facility.departments
          .map(e => ({
            label: e.name,
            value: e.id,
          }))
          .sort((a, b) => (a.label > b.label ? 1 : -1))

        if (facility.managedByCurrentUser) {
          departments.unshift({
            label: "All Departments",
            value: null,
          })
          defaultEntityId = facility.id
          defaultEntityType = "facility"
        } else {
          defaultEntityId = departments[0].value
          defaultEntityType = "department"
        }

        return {
          departments,
          defaultEntityId,
          defaultEntityType,
        }
      }
    },
  })
)(UtilizationSummaryTableControlled)
